import StyleToObject from './index.js';

export default StyleToObject;
